export default "__VITE_ASSET__DMpE3Rm6__"